<template>
    <div class="document-email-page">
        <div class="document-email-page__header">
            <h2>{{ $l10n.__('Emails') }}</h2>
            <CompassButton
                :label="$t.__('common.actions.send_email')"
                type="primary"
                size="medium"
                @click="checkIsEmailSetUp"
            ></CompassButton>
        </div>
        <timeline
            :linkedtype="linkedtype"
            :linkedid="parseInt(linkedid)"
            :overviewType="linkedtype"
            isDocument
        />
    </div>
</template>

<script>
import Timeline from 'vcomponents/timeline/Timeline.vue';
import EmailMixins from '../../mixins/EmailMixins';
import Store from 'stores/overview/document/store';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    components: {
        Timeline,
    },
    mixins: [EmailMixins],
    props: {
        linkedtype: {
            type: String,
            required: true,
        },
        linkedid: {
            type: [String, Number],
            required: true,
        },
        doclabel: {
            type: String,
            default: '',
        },
        fileid: {
            type: String,
            default: '',
        },
    },
    computed: {
        ...mapState(['fileId', 'docFile']),
    },
    async created() {
        this.getSettings();

        if (!this.$store.state.documentOverview) {
            this.$store.registerModule('documentOverview', Store);

            this.$store.commit('documentOverview/init', {
                doclabel: this.doclabel,
                fileId: this.fileid,
            });
        }

        if (!this.fileId) {
            this.$store.dispatch('documentOverview/setFileId', this.fileid);
        }

        if (!this.docFile) {
            this.$store.dispatch('documentOverview/getDocFile');
        }
    },
    methods: {
        async checkIsEmailSetUp() {
            if (!this.docFile) {
                await this.$store.dispatch('documentOverview/getDocFile');
            }

            let templateType = this.linkedtype;
            let paramsLinkedType = this.linkedtype;
            switch (this.linkedtype) {
                case 'propdocument':
                    templateType = paramsLinkedType = 'proposal';
                    break;
                default:
                    templateType = 'document';
                    break;
            }

            const params = {
                relatedtype: paramsLinkedType,
                relatedid: this.linkedid,
                doclabel: this.doclabel,
                template: {
                    type: templateType,
                    contact: {
                        id: parseInt(this.linkedid),
                        type: paramsLinkedType,
                    },
                    related: [
                        {
                            id: parseInt(this.linkedid),
                            type: paramsLinkedType,
                        },
                    ],
                },
            };

            this.checkEmailProvider(params, { checkPrefill: true });
        },
    },
};
</script>
<style lang="scss" scoped>
.document-email-page {
    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        h2 {
            margin: 0;
        }
    }
}
</style>
